(function () {
  "use strict";

  let running = false;

  async function updateSnapCartImages() {
    if (running) return;

    running = true;

    try {
      const response = await fetch("/cart.js", {
        credentials: "same-origin"
      });

      if (!response.ok) {
        return;
      }

      const cart = await response.json();

      if (!cart || !Array.isArray(cart.items)) {
        return;
      }

      const customItems = cart.items.filter(function (item) {
        return (
          item.properties &&
          item.properties._custom_preview
        );
      });

      if (!customItems.length) {
        return;
      }

      /*
        Find cart drawer images.
        We deliberately ignore product-page images.
      */

      const allImages =
        Array.from(
          document.querySelectorAll("img")
        ).filter(function (img) {

          const rect =
            img.getBoundingClientRect();

          const width =
            rect.width || img.width;

          const height =
            rect.height || img.height;

          /*
            Snap Cart product thumbnails are
            generally small square/rectangular images.
          */

          return (
            width >= 45 &&
            width <= 180 &&
            height >= 45 &&
            height <= 220
          );
        });


      customItems.forEach(function (item) {

        const preview =
          item.properties._custom_preview;

        if (!preview) {
          return;
        }


        /*
          Locate the current normal Shopify
          image for this exact cart product.
        */

        const originalUrl =
          item.image
            ? item.image.split("?")[0]
            : "";


        const matchingImage =
          allImages.find(function (img) {

            const src =
              (img.currentSrc || img.src || "")
                .split("?")[0];

            if (
              originalUrl &&
              src.indexOf(originalUrl) !== -1
            ) {
              return true;
            }

            return false;
          });


        if (!matchingImage) {
          return;
        }


        matchingImage.src =
          preview;

        matchingImage.removeAttribute(
          "srcset"
        );

        matchingImage.alt =
          "Your custom label design";

        matchingImage.style.objectFit =
          "contain";

        matchingImage.setAttribute(
          "data-sil-custom-preview",
          "true"
        );

      });

    }

    catch (error) {
      console.warn(
        "Sew It In Labels: cart preview could not be updated.",
        error
      );
    }

    finally {
      running = false;
    }
  }


  /*
    Initial checks
  */

  document.addEventListener(
    "DOMContentLoaded",
    function () {

      updateSnapCartImages();

      setTimeout(
        updateSnapCartImages,
        500
      );

      setTimeout(
        updateSnapCartImages,
        1200
      );

    }
  );


  /*
    Snap Cart rebuilds its drawer after
    adding/removing/changing cart items.
  */

  const observer =
    new MutationObserver(function () {

      clearTimeout(
        window.silSnapCartPreviewTimer
      );

      window.silSnapCartPreviewTimer =
        setTimeout(
          updateSnapCartImages,
          120
        );

    });


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();